const billing = {
    title: 'Abrechnung & Abonnements',
    revenue: 'Umsatz',
    subscriptions: 'Abonnements',
    invoices: 'Rechnungen',
  } as const;

export default billing;
